import type { BooleanInputProps } from '@healthnz-prm/fhir-engine-renderer/types'
import { InputFieldset } from '../inputFieldset'
import { ToggleGroup, ToggleGroupItem } from '@/components/ui/toggle-group'

export default function BooleanInput(props: BooleanInputProps) {
  const { value, disabled, onChange } = props

  function handleChange(newValue: string) {
    switch (newValue) {
      case 'yes':
        return onChange(true)
      case 'no':
        return onChange(false)
      default:
        return onChange(null)
    }
  }

  return (
    <InputFieldset {...props}>
      <ToggleGroup
        disabled={disabled}
        value={
          (value === true && 'yes') || (value === false && 'no') || undefined
        }
        onValueChange={handleChange}
        type='single'
        variant='outline'
        size='lg'
      >
        <ToggleGroupItem value='yes'>Yes</ToggleGroupItem>
        <ToggleGroupItem value='no'>No</ToggleGroupItem>
      </ToggleGroup>
    </InputFieldset>
  )
}
